export const sessionIdSelector = (state) => state.getIn(['authorization', 'sessionId'])
